import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon, ArrowUpRightIcon } from "lucide-react";
import type { Project } from "../data/projects";
import { SunMark } from "./SunMark";
import { TreatedImage } from "./TreatedImage";
import { EYEBROW, H3 } from "../utils/typography";
type ProjectCardProps = {
  project: Project;
};
export function ProjectCard({
  project
}: ProjectCardProps) {
  const isInvite = project.kind === "invite";
  return <article className="h-full" data-id="element-333" data-mp="2gi0vvkm7fs0o">
      <Link to={project.href}
    // Scroll even if the URL already ends in #contact (a repeat click wouldn't re-trigger)
    onClick={isInvite ? () => document.getElementById("contact")?.scrollIntoView({
      behavior: "smooth"
    }) : undefined} className="group flex h-full flex-col focus:outline-none" data-id="element-334" data-mp="2ljhv7bp1j6f5">
        <div className="relative overflow-hidden rounded-3xl bg-paper ring-offset-4 ring-offset-cream group-focus-visible:ring-2 group-focus-visible:ring-rust" data-id="element-335" data-mp="105lt87125zez">
          {isInvite ? <div className="relative aspect-[4/3] w-full bg-espresso" aria-hidden="true" data-id="element-336" data-mp="1ih9r4t3ks5p">
              <SunMark className="absolute bottom-0 left-1/2 w-[55%] -translate-x-1/2 translate-y-[45%] text-dusty transition-transform duration-300 ease-out group-hover:translate-y-[35%]" data-id="element-337" data-mp="3sp0imefdi81d" />
            </div> : project.image && <TreatedImage src={project.image} alt={`${project.title} — ${project.client}`} className="aspect-[4/3] w-full" motionMask={project.motionMask} motionStyle={project.motionStyle} interactive data-id="element-338" data-mp="kegrlmsd2fbk" />}
        </div>

        <div className="mt-5 flex flex-wrap items-center justify-between gap-x-4 gap-y-2" data-id="element-339" data-mp="p8l1oewxb3gv">
          <p className={`min-w-0 ${EYEBROW} text-espresso/70`} data-id="element-340" data-mp="133vu7lnp3ci2">
            {project.client}
          </p>
          <ul className="hidden gap-2 sm:flex" data-id="element-341" data-mp="y52edmkxr9eq">
            {project.tags.map(tag => <li key={tag} className="whitespace-nowrap rounded-full border border-espresso/15 px-3 py-1 text-xs font-medium uppercase tracking-wide text-espresso/70" data-id="element-342" data-mp="3rwsd6f1zjepk">
                {tag}
              </li>)}
          </ul>
        </div>

        <div className="mt-3 flex flex-1 items-start justify-between gap-6" data-id="element-343" data-mp="9myplsstanx5">
          <div data-id="element-344" data-mp="ejgs0m0o6a6b">
            <h3 className={`${H3} text-espresso`} data-id="element-345" data-mp="em2zklnk8poj">
              {project.title}
            </h3>
            <p className="mt-2 max-w-md text-espresso/70" data-id="element-346" data-mp="jl65s9fa11y3">{project.description}</p>
          </div>

          {isInvite ? <span className="mt-1 flex h-10 shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-espresso px-5 text-sm font-medium uppercase text-cream transition-colors duration-150 group-hover:bg-rust" data-id="element-347" data-mp="sjhug5wl1pnw">
              {project.cta}
              <ArrowRightIcon className="h-4 w-4" data-id="element-348" data-mp="2ubwb71ne4o2q" />
            </span> : <span className="mt-1 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-espresso text-cream transition-colors duration-150 group-hover:bg-rust" data-id="element-349" data-mp="2msnby18lm5re">
              <ArrowUpRightIcon className="h-4 w-4" data-id="element-350" data-mp="2d1iumuvga8te" />
            </span>}
        </div>
      </Link>
    </article>;
}